import { CloseOutlined } from "@ant-design/icons";
import { AddFilter, FilterItem } from "@/controls";
import { Button, Form } from "antd";
import { useState, useEffect, useRef } from "react";
import TriStateCheckbox from "../../controls/tri-state-checkbox";
import { storeDocVids } from "../../extensions/helper";

const StockFilter = ({ items = [], value, onClose, allClientOutOptions = [], allClientInOptions = [] }) => {
  const emptyFilter = { Active: null };
  const [tempFilter, setTempFilter] = useState(() => {
    try {
      const saved = localStorage.getItem('stockDocsFilter');
      if (saved) {
        return JSON.parse(saved);
      }
    } catch {}
    return emptyFilter;
  });

  useEffect(() => {
    if (value && Object.keys(value).length > 0) {
      setTempFilter(value);
    }
  }, [value]);

  const [addingFilter, setAddingFilter] = useState(false);

  const filterOptions = [
    { type: "clientOutIds", label: "Отправитель", tooltip: "Отправитель", inputType: "multiselect", options: allClientOutOptions },
    { type: "clientInIds", label: "Получатель", tooltip: "Получатель", inputType: "multiselect", options: allClientInOptions },
    { type: "documentVidIds", label: "Вид документа", tooltip: "По виду документа", inputType: "multiselect", options: storeDocVids, width: 250 },
  ];

  const filterLabels = {
    clientOutIds: "Отправитель",
    clientInIds: "Получатель",
    documentVidIds: "Вид документа",
  };

  const renderFilterItem = (key, data) => {
    const staticOption = filterOptions.find(f => f.type === key); // Опции из текущих items
    const normalized = typeof data === 'object' && data !== null && !Array.isArray(data) && 'value' in data
      ? data
      : { value: data };
    const savedOptions = Array.isArray(normalized.options) ? normalized.options : []; // Опции, которые пришли в value
    const staticOptions = staticOption?.options || [];
    const combinedOptions = Array.from(new Map([...savedOptions, ...staticOptions].map(obj => [obj.value, obj])).values());
    
    return (
      <Form.Item key={key} label={filterLabels[key] || key} style={{ width: "100%" }}>
        <FilterItem key={key} type={staticOption?.inputType} value={normalized.value} options={combinedOptions}
          onChange={(val) => onFilterChange({ [key]: val })}
          onRemove={() => {
            const { [key]: _, ...rest } = tempFilter;
            setTempFilter(rest);
          }}
        />
      </Form.Item>
    );
  };

  const filters = Object.entries(tempFilter)
    .filter(([key]) => !["dateFrom", "dateTo", "Active"].includes(key))
    .map(([type, data]) => {
      const normalized = typeof data === 'object' && data !== null && !Array.isArray(data) && 'value' in data
        ? data
        : { value: data };
      return { type, ...normalized };
    });

  const onFilterChange = (changedValues) => {
    setTempFilter(prev => {
      const next = { ...prev };
      Object.keys(changedValues).forEach(key => {
        if (prev[key] && typeof prev[key] === 'object' && 'value' in prev[key]) {
          next[key] = { ...prev[key], value: changedValues[key] };
        } else {
          next[key] = changedValues[key];
        }
      });
      return next;
    });
  };

  const handleAddTopFilter = (type) => {
    if (tempFilter[type]) return;
    const option = filterOptions.find(opt => opt.type === type);
    const inputType = option?.inputType;
    let initialValue = undefined;
    let options = option?.options;
    onFilterChange({ [type]: { value: initialValue, inputType, options }});
    setAddingFilter(false);
  };

  return (
    <div className="sport-modal">
      <div className="sport-modal-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose(false)}>
        <div className="sport-modal-content" onMouseDown={e => e.stopPropagation()}>
          <div className="sport-modal-title">
            <span>Фильтр</span>
            <CloseOutlined className="sport-section-title-close" onClick={() => onClose(false)} style={{ zIndex: 9 }} />
          </div>
          <div className="stock-filter-container">
            {filters.length === 0 && !addingFilter && (
              <AddFilter availableFilters={filterOptions} usedFilters={filters.map(f => f.type)} onAdd={handleAddTopFilter} />
            )}
            {filters.map((f) => renderFilterItem(f.type, f))}
            {filters.length < filterOptions.length && (
              addingFilter ? (
                <AddFilter availableFilters={filterOptions} usedFilters={filters.map(f => f.type)} onAdd={handleAddTopFilter} />
              ) : (
                filters.length !== 0 && (
                  <Button onClick={() => setAddingFilter(true)} type="dashed" className="filter-add-button">+</Button>
                )
              )
            )}
            <TriStateCheckbox name="Active" value={tempFilter.Active} onChange={(val) => onFilterChange({ Active: val })}>
              Активный
            </TriStateCheckbox>
            <Button onClick={() => {
              const result = { ...tempFilter };
              if (value?.dateFrom && !result.dateFrom) result.dateFrom = value.dateFrom;
              if (value?.dateTo && !result.dateTo) result.dateTo = value.dateTo;
              const mergedClientOutIds = filterOptions.find(f => f.type === 'clientOutIds');
              const mergedClientInIds = filterOptions.find(f => f.type === 'clientInIds');
              if (mergedClientOutIds && result.clientOutIds) {
                result.clientOutIds = { ...result.clientOutIds, options: mergedClientOutIds.options };
              }
              if (mergedClientInIds && result.clientInIds) {
                result.clientInIds = { ...result.clientInIds, options: mergedClientInIds.options };
              }
              onClose(result);
            }}>ОК</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockFilter;